export default __webpack_public_path__ + "static/media/card4.218ce0e4.png";